import { KIND_LABEL } from "./sections";

const typeLabel = (r) => {
    if (r.row_type === "flex") return "Flessibile";
    if (r.row_type === "fitting") return `Pezzi speciali (${r.note?.replace("pezzi speciali (equiv.): ", "") || ""})`;
    return "Canale";
};

export function downloadCsv({ mandata, ripresa, altro = [], plenum_count, griglia_count, anomalies, fittings = [] }, meta) {
    const sum = (rows, k) => rows.reduce((s, r) => s + (Number(r[k]) || 0), 0);
    const rows = [["Rete", "Sezione", "Tipo", "Metri lineari", "m² lamiera"]];
    mandata.forEach((r) => rows.push(["Mandata", r.section, typeLabel(r), r.length_m, r.area_m2]));
    ripresa.forEach((r) => rows.push(["Ripresa", r.section, typeLabel(r), r.length_m, r.area_m2]));
    altro.forEach((r) => rows.push(["Altra rete", r.section, typeLabel(r), r.length_m, r.area_m2]));
    rows.push([]);
    rows.push(["TOTALE MANDATA", "", "", sum(mandata, "length_m").toFixed(2), sum(mandata, "area_m2").toFixed(2)]);
    rows.push(["TOTALE RIPRESA", "", "", sum(ripresa, "length_m").toFixed(2), sum(ripresa, "area_m2").toFixed(2)]);
    if (altro.length) rows.push(["TOTALE ALTRA RETE", "", "", sum(altro, "length_m").toFixed(2), sum(altro, "area_m2").toFixed(2)]);
    rows.push(["TOTALE M+R", "", "", (sum(mandata, "length_m") + sum(ripresa, "length_m")).toFixed(2), (sum(mandata, "area_m2") + sum(ripresa, "area_m2")).toFixed(2)]);
    rows.push([]);
    rows.push(["Plenum totali", plenum_count]);
    rows.push(["Griglie totali", griglia_count]);
    if (fittings.length) {
        rows.push([]);
        rows.push(["PEZZI SPECIALI", "Rete", "Tipo", "Quantità", "Lunghezza equiv. (m)"]);
        fittings.forEach((f) => rows.push(["", KIND_LABEL[f.kind] || f.kind, f.type, f.count, f.eq_length_m]));
    }
    if (anomalies?.length) {
        rows.push([]);
        rows.push(["ANOMALIE / NOTE"]);
        anomalies.forEach((a) => rows.push([a.kind, a.detail]));
    }
    const csv = rows.map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(";")).join("\n");
    const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const base = (meta?.dxfName || "computo").replace(/\.[^.]+$/, "");
    a.download = `computo_canali_${base}_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}
